import React from 'react';

import { WithStyles, withStyles, useMediaQuery } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';

import { styles } from './ContractAdvice.style';

function ContractAdvice(props: WithStyles<typeof styles>) {
    const { classes } = props;
    const mobileStart = useMediaQuery('(max-width:749px)');

    return (
        <div>
            <Grid container className={classes.subGridTitle}>
                <Grid item xs={12}>
                    <Box className={classes.titleContainer}>
                        <p className={classes.title}>AVISO DE MODIFICACIÓN</p>
                        <p id="bot" className={classes.title}>
                            EN TU CONTRATO DE ADHESIÓN
                        </p>
                    </Box>

                    <Box className={classes.section}>
                        <p className={classes.text}>
                            <strong>Cuenta de Fondos de Pago Electrónico</strong>
                        </p>
                        <p className={classes.text}>
                            <strong>RECA NÚM: 15717-458-044419/01-02183-0926</strong>
                        </p>
                    </Box>
                    <Box className={classes.section}>
                        <p className={classes.text}>
                            En cumplimiento a lo establecido en las Disposiciones de Carácter General de la CONDUSEF en
                            materia de transparencia y sanas prácticas aplicables a las Instituciones de Tecnología
                            Financiera, te notificamos que{' '}
                            <strong>
                                en un plazo de 30 (treinta) días naturales posteriores a que recibas este aviso
                            </strong>{' '}
                            entrarán en vigor el nuevo Contrato de Adhesión de Emisión y Depósito Mercantil de Fondos de
                            Pago Electrónico (el <strong>“Contrato”</strong>), celebrado con Cuenca Tecnología
                            Financiera, S.A. de C.V., Institución de Fondos de Pago Electrónico (
                            <strong>“Cuenca”</strong>).
                        </p>
                        <p className={classes.text}>
                            El contrato se encuentra inscrito en el Registro de Contratos de Adhesión de la CONDUSEF (
                            <strong>“RECA”</strong>) bajo el número <strong>15717-458-044419/01-02183-0926</strong>, y
                            reemplaza la versión anterior con número 15717-458-035582/05-02440-0925.
                        </p>
                    </Box>
                    <Box className={classes.section}>
                        <p className={classes.subtitle}>
                            <strong>Aspectos Relevantes</strong>
                        </p>
                    </Box>
                </Grid>
            </Grid>

            <Grid container className={classes.subGridClauses}>
                <Grid item xs={mobileStart ? 12 : 4}>
                    <p className={classes.subtitle}>Comisiones</p>
                </Grid>
                <Grid item xs={mobileStart ? 12 : 8}>
                    <p className={classes.text}>- Se mantiene el importe de las comisiones sin cambios.</p>
                </Grid>
            </Grid>
            <Grid container className={classes.subGridClauses}>
                <Grid item xs={mobileStart ? 12 : 4}>
                    <p className={classes.subtitle}>Definiciones y estructura</p>
                </Grid>
                <Grid item xs={mobileStart ? 12 : 8}>
                    <p className={classes.text}>- Se incorpora la definición Unidad de Medida y Actualización (UMA).</p>
                </Grid>
            </Grid>
            <Grid container className={classes.subGridClauses}>
                <Grid item xs={mobileStart ? 12 : 4}>
                    <p className={classes.subtitle}>Aceptación de Personas Morales</p>
                </Grid>
                <Grid item xs={mobileStart ? 12 : 8}>
                    <p className={classes.text}>
                        - Se fortalece el procedimiento de aceptación y contratación de Personas Morales, precisando los
                        requisitos y condiciones aplicables para su incorporación como Clientes de Cuenca.
                    </p>
                </Grid>
            </Grid>
            <Grid container className={classes.subGridClauses}>
                <Grid item xs={mobileStart ? 12 : 4}>
                    <p className={classes.subtitle}>Flujo de Domiciliaciones</p>
                </Grid>
                <Grid item xs={mobileStart ? 12 : 8}>
                    <p className={classes.text}>
                        - Se mejora y actualiza el flujo operativo para atención del servicio de Domiciliaciones,
                        precisando las funcionalidades disponibles en la Aplicación y los medios de atención y
                        notificación al Cliente.
                    </p>
                </Grid>
            </Grid>
            <Grid container className={classes.subGridClauses}>
                <Grid item xs={mobileStart ? 12 : 4}>
                    <p className={classes.subtitle}>Canal de Comunicación</p>
                </Grid>
                <Grid item xs={mobileStart ? 12 : 8}>
                    <p className={classes.text}>
                        - Se incorpora WhatsApp como el canal de comunicación para presentar avisos y objeciones.
                    </p>
                </Grid>
            </Grid>
            <Grid container className={classes.subGridClauses}>
                <Grid item xs={mobileStart ? 12 : 4}>
                    <p className={classes.subtitle}>Cuentas sin movimientos</p>
                </Grid>
                <Grid item xs={mobileStart ? 12 : 8}>
                    <p className={classes.text}>
                        - Se aclara que el Cliente podrá solicitar el reintegro de sus recursos antes de que opere la
                        prescripción, previa validación de su identidad con el área de Soporte a Clientes.
                    </p>
                </Grid>
            </Grid>
            <Grid container className={classes.subGridClauses}>
                <Grid item xs={mobileStart ? 12 : 4}>
                    <p className={classes.subtitle}>Reactivación y cancelación de cuentas</p>
                </Grid>
                <Grid item xs={mobileStart ? 12 : 8}>
                    <p className={classes.text}>
                        - Se precisan los casos en los que una cuenta suspendida no podrá ser reactivada y las causas
                        por las que Cuenca podrá cancelarla de forma definitiva, principalmente por motivos de
                        prevención de fraude, PLD/FT, información falsa o uso indebido de la cuenta.
                    </p>
                </Grid>
            </Grid>
            <Grid container className={classes.subGridClauses}>
                <Grid item xs={mobileStart ? 12 : 4}>
                    <p className={classes.subtitle}>Cobertura geográfica</p>
                </Grid>
                <Grid item xs={mobileStart ? 12 : 8}>
                    <p className={classes.text}>
                        - Por motivos de seguridad y cumplimiento normativo, el acceso a la Plataforma podrá estar
                        restringido desde determinados países o regiones; este listado estará actualizado y disponible
                        para consulta del Cliente en la Plataforma.
                    </p>
                </Grid>
            </Grid>

            <Grid container className={classes.subGridTitle}>
                <Grid item xs={12}>
                    <Box className={classes.section}>
                        <p className={classes.subtitle}>
                            <strong>Derecho de terminación</strong>
                        </p>
                    </Box>

                    <Box className={classes.section}>
                        <p className={classes.text}>
                            Recuerda que dentro de los 30 (treinta) días naturales posteriores a que recibas esta
                            notificación podrás dar por terminado tu Contrato en la Aplicación sin responsabilidad
                            alguna ni cobro de penalizaciones, bajo las condiciones pactadas previamente, en el
                            entendido que solo se te pedirá cubrir únicamente, en su caso, los adeudos generados hasta
                            el término de tu cuenta. En caso de no recibir tu respuesta se entenderá que has aceptado
                            los términos actualizados.
                        </p>
                    </Box>
                    <Box className={classes.section}>
                        <p className={classes.subtitle}>
                            <strong>Consulta del Contrato</strong>
                        </p>
                    </Box>
                    <Box className={classes.section}>
                        <p className={classes.text}>Podrás revisar el texto íntegro del contrato:</p>
                        <ul>
                            <li className={classes.text}>
                                En la sección de Legales de esta página y en tu aplicación.
                            </li>
                            <li className={classes.text}>
                                En el portal RECA de la CONDUSEF: <em>www.condusef.gob.mx</em>
                            </li>
                        </ul>
                    </Box>
                </Grid>
            </Grid>
        </div>
    );
}

export default withStyles(styles)(ContractAdvice);
